module.exports = __webpack_public_path__ + "static/media/BigCaslonRegular.3994fd04.otf";